import React, { Component } from "react";
import ZoomIn from "@material-ui/icons/ZoomIn";
import COLORS from "../theme/colors";
import ImageLightbox, { toImageSrc } from "./ImageLightbox";
import { thumbStyles } from "./Base64Image";

const styles = {
  count: { margin: "8px 0 12px", color: COLORS.muted, fontSize: 14 },
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))", gap: 12, maxWidth: 1000 },
  tile: {
    position: "relative",
    display: "block",
    width: "100%",
    paddingTop: "75%", // 4:3 tile
    border: `1px solid ${COLORS.border}`,
    borderRadius: 12,
    overflow: "hidden",
    background: COLORS.field,
    cursor: "zoom-in"
  },
  image: { position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover" },
  empty: {
    maxWidth: 1000,
    padding: "28px 16px",
    border: `1px dashed ${COLORS.border}`,
    borderRadius: 12,
    color: COLORS.muted,
    fontSize: 14,
    textAlign: "center",
    background: COLORS.field
  }
};

const photosLabel = n => (n === 1 ? "1 slika" : n === 2 ? "2 sliki" : n === 3 || n === 4 ? `${n} slike` : `${n} slik`);

/** Slike tab: montage photos as a grid of thumbnails; click one to see it large and browse. */
class Base64ImageInstallation extends Component {
  state = { open: null };

  render() {
    const record = this.props.record || {};
    const images = (record.images || [])
      .filter(item => item && item.image)
      .map((item, index) => ({ id: item.id || index, title: `Slika ${index + 1}`, src: toImageSrc(item.image) }));

    if (images.length === 0) {
      return <div style={{ ...styles.empty, marginTop: 8 }}>Ni slik montaže.</div>;
    }

    return (
      <div>
        <div style={styles.count}>{photosLabel(images.length)} · klikni sliko za večji prikaz</div>
        <div style={styles.grid}>
          {images.map((image, index) => (
            <button
              key={image.id}
              type="button"
              style={styles.tile}
              onClick={() => this.setState({ open: index })}
              title="Odpri večji prikaz"
              aria-label={`${image.title} – odpri večji prikaz`}
            >
              <img src={image.src} alt={image.title} style={styles.image} />
              <ZoomIn style={thumbStyles.zoom} />
            </button>
          ))}
        </div>
        <ImageLightbox
          images={images}
          index={this.state.open}
          onChange={open => this.setState({ open })}
          onClose={() => this.setState({ open: null })}
        />
      </div>
    );
  }
}

export default Base64ImageInstallation;
